export default __webpack_public_path__ + "static/media/chrome-phone-4.e279fe02.jpg";